import store from './store';
import all from './all';
import update from './update';
import destroy from './destroy';
import show from './show';

export default {
  store,
  all,
  update,
  destroy,
  show,
};



// WEBPACK FOOTER //
// ./src/app/services/packageOrderProduct/index.js